import { Box, Button, Stack, Text } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";

const DARK_BLUE_BG = "var(--mantine-color-primary-6)";

type AiGenerationErrorStateProps = {
  message?: string;
  onRetry?: () => void;
  retrying?: boolean;
  minHeight?: number;
};

export default function AiGenerationErrorState({
  message = "Something went wrong. Please generate again.",
  onRetry,
  retrying = false,
  minHeight = 200,
}: AiGenerationErrorStateProps) {
  return (
    <Box
      p="xl"
      mih={minHeight}
      style={{
        borderRadius: 12,
        backgroundColor: DARK_BLUE_BG,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack align="center" gap="md" py="md" maw={420}>
        <Text fw={600} size="md" c="white" ta="center" lh={1.5}>
          {message}
        </Text>
        {onRetry ? (
          <Button
            variant="white"
            color="dark"
            leftSection={<IconRefresh size={16} />}
            onClick={onRetry}
            loading={retrying}
          >
            Generate again
          </Button>
        ) : null}
      </Stack>
    </Box>
  );
}
